//selectedInvestmentForAppraisalslice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GlobalFund {
    region:string,
    fundId:string,
    fundName:string
  }

interface InitialState {
    data: GlobalFund ,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as GlobalFund,
    error: '',
    loading: false
}

const selectedGlobalFundForAppraisal = createSlice({
    name: "selectedGlobalFundForAppraisal",
    initialState,
    reducers: {
        updateSelectedGlobalFundAppraisal(state, action: PayloadAction<GlobalFund>) {
            state.data = action.payload;
        },
    },
});

export const { updateSelectedGlobalFundAppraisal } = selectedGlobalFundForAppraisal.actions;

export default selectedGlobalFundForAppraisal.reducer;